import Component from './header';
export default Component;
